<template>
  <div>
    <v-list-item :style="itemStyle" @click="item.action">
      <div
        v-if="item.icon"
        style="width: 32px; display: flex; justify-content: center"
      >
        <v-icon :class="active ? 'sidebar-active-icon' : 'sidebar-icon'">{{
          item.icon
        }}</v-icon>
      </div>

      <div v-if="item.loading" style="width: 32px; display: flex">
        <v-progress-circular
          :size="20"
          :width="2"
          indeterminate
          color="primary"
        />
      </div>

      <v-list-item-content>
        <v-list-item-title
          :class="active ? 'sidebar-active-text' : 'sidebar-text'"
          style="margin-right: 20px"
          >{{ item.text }}</v-list-item-title
        >
      </v-list-item-content>

      <v-icon
        v-if="item.childItems"
        @click="openChildList = !openChildList"
        class="sidebar-icon"
        >{{ openChildList ? "fa-chevron-up" : "fa-chevron-down" }}</v-icon
      >
    </v-list-item>

    <v-list v-if="item.childItems && openChildList" style="padding: 0">
      <item
        v-for="(item, i) in item.childItems"
        :key="i"
        :item="item"
        :level="level + 1"
      />
    </v-list>
  </div>
</template>

<script>
export default {
  name: "user-menu-item",

  data: () => ({
    openChildList: false,
    active: false,
  }),

  props: ["item", "level"],

  computed: {
    itemStyle() {
      return {
        "margin-left": `${this.level * 20}px`,
        display: "flex",
        "justify-content": "space-between",
        padding: "5px 0 !important",
        "border-bottom": "solid 1px #64c832",
        cursor: "pointer",
      };
    },
  },
};
</script>

<style scoped>
.sidebar-icon {
  color: var(--v-primary-base) !important;

  margin: 0 10px 0 0;

  font-size: 1.2em !important;
}

.sidebar-active-icon {
  color: #ffcd00 !important;

  margin: 0 10px 0 0;

  font-size: 1.2em !important;
}

.sidebar-text {
  color: var(--v-primary-base);
}

.sidebar-active-text {
  color: #ffcd00;
}
</style>
